module.exports = __webpack_public_path__ + "static/media/3423.31d0baf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/3423.png
// module id = 110
// module chunks = 6